module.exports = __webpack_public_path__ + "static/media/run-workflow.94623942.png";